<script lang="ts">
    import {
        CircleMarker,
        Popup,
        Tooltip
    } from "../svelteLeafletWrapper";
    import Logo from "./Logo.svelte";
    import {point2LatLng} from "../latlngCalc"

    export let sectorId: number;
    export let fairway: Fairway;

    let current: currentPoint;

    $: current = sectorId ? convert(sectorId, fairway) : null;

    type currentPoint = {
        name: string;
        central_coordinate_x: number;
        central_coordinate_y: number;
        move_range: number;
        sector_id: number;
    }

    function convert(sectorId: number, fairway: Fairway): currentPoint {
        if (fairway.sector_id_alpha == sectorId) {
            return {
                name: 'Unknown Sector',
                central_coordinate_x: fairway.central_coordinate_alpha_x,
                central_coordinate_y: fairway.central_coordinate_alpha_y,
                move_range: fairway.move_range_alpha,
                sector_id: sectorId
            }
        }
        return {
            name: 'Unknown Sector',
            central_coordinate_x: fairway.central_coordinate_beta_x,
            central_coordinate_y: fairway.central_coordinate_beta_y,
            move_range: fairway.move_range_beta,
            sector_id: sectorId
        };
    }
</script>
{#if current}
    <CircleMarker latLng={point2LatLng(current.central_coordinate_x, current.central_coordinate_y)}
                  radius={current.move_range * 10}>
        <Popup options={{"minWidth": 200}}>
            <div>座標: { current.central_coordinate_x } x {current.central_coordinate_y }</div>
            <div>航路接続帯</div>
            <Logo name="{current.name}"/>
        </Popup>
        <Tooltip>({ current.central_coordinate_x } x {current.central_coordinate_y }) 航路接続帯:{current.name}</Tooltip>
    </CircleMarker>
{/if}